<template>
  <FadeInTransition>
    <div
      class="flex size-full flex-col items-center justify-center bg-white pt-4 text-center md:-mt-16 md:max-w-[45rem] md:pt-8"
    >
      <div class="flex animate-slide-up flex-col items-center">
        <h2
          v-dompurify-html="$t(label)"
          class="mb-8 text-2xl font-medium md:text-4xl"
        ></h2>
        <FimLoadingSpinner />
      </div>
    </div>
  </FadeInTransition>
</template>
<script setup lang="ts">
const props = defineProps({
  isEditing: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
})

const label = computed(() =>
  props.isEditing ? 'rxConfigurator.loading_editing' : 'rxConfigurator.loading',
)
</script>
